import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-244b8dc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "agenda-wrapper" }
const _hoisted_2 = { class: "agenda-header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "display-6 fw-bold text-dark mb-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-calendar-days text-primary me-3" }),
  /*#__PURE__*/_createTextVNode(" Mon Agenda ")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "text-muted fs-5 mb-0"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary mx-2" }, "•", -1))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "card border-0 shadow-sm mt-4" }
const _hoisted_9 = { class: "card-body p-4" }
const _hoisted_10 = {
  class: "nav nav-tabs premium-tabs",
  role: "tablist"
}
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-clock me-2" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "badge bg-primary rounded-pill ms-2"
}
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-calendar-check me-2" }, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "badge bg-success rounded-pill ms-2"
}
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-table-cells-large me-2" }, null, -1))
const _hoisted_19 = { class: "tab-content mt-4" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "row g-4" }
const _hoisted_22 = { class: "col-lg-8" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fw-semibold text-dark mb-4" }, "Prochains 7 jours", -1))
const _hoisted_24 = {
  key: 0,
  class: "text-center py-6"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  style: {"width":"3rem","height":"3rem"}
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3 text-muted" }, "Chargement de votre planning...", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "alert alert-light border text-center py-5"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-calendar-xmark fa-3x text-muted mb-3" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-muted" }, "Aucun cours prévu pour les 7 prochains jours", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_34 = { class: "flex-grow-1" }
const _hoisted_35 = { class: "mb-1 fw-bold text-dark" }
const _hoisted_36 = { class: "text-muted mb-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-tie me-2" }, null, -1))
const _hoisted_38 = { class: "d-flex flex-wrap gap-3 text-sm text-muted" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-calendar me-2" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-clock me-2" }, null, -1))
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-location-dot me-2" }, null, -1))
const _hoisted_43 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_44 = ["href"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-video me-2" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-up-right-from-square ms-2" }, null, -1))
const _hoisted_47 = {
  key: 1,
  disabled: "",
  class: "btn btn-secondary"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-check-circle me-2" }, null, -1))
const _hoisted_49 = { class: "col-lg-4" }
const _hoisted_50 = {
  key: 0,
  class: "card border-0 shadow-lg bg-gradient-primary text-white mb-4"
}
const _hoisted_51 = { class: "card-body p-4" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-star me-2" }),
  /*#__PURE__*/_createTextVNode(" Prochain cours")
], -1))
const _hoisted_53 = { class: "fw-bold" }
const _hoisted_54 = { class: "mb-1 opacity-90" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-calendar me-1" }, null, -1))
const _hoisted_56 = { class: "mb-3 opacity-90" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-clock me-1" }, null, -1))
const _hoisted_58 = ["href"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-video me-2" }, null, -1))
const _hoisted_60 = { class: "card border-0 shadow-sm" }
const _hoisted_61 = { class: "card-body" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chart-pie me-2" }),
  /*#__PURE__*/_createTextVNode(" Cette semaine")
], -1))
const _hoisted_63 = { class: "stats-grid" }
const _hoisted_64 = { class: "stat-item" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Total", -1))
const _hoisted_66 = { class: "text-primary fs-4" }
const _hoisted_67 = { class: "stat-item" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "En ligne", -1))
const _hoisted_69 = { class: "text-success fs-4" }
const _hoisted_70 = { class: "stat-item" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Présentiel", -1))
const _hoisted_72 = { class: "text-info fs-4" }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { class: "fw-semibold mb-4" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-sun me-2 text-warning" }, null, -1))
const _hoisted_76 = {
  key: 0,
  class: "text-center py-6"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  style: {"width":"3rem","height":"3rem"}
}, null, -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = {
  key: 1,
  class: "alert alert-success py-5 text-center border-0 shadow-sm"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-party-horn fa-3x mb-3 text-success" }, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Pas de cours aujourd'hui !", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Profitez bien de votre journée", -1))
const _hoisted_83 = [
  _hoisted_80,
  _hoisted_81,
  _hoisted_82
]
const _hoisted_84 = {
  key: 2,
  class: "timeline-modern"
}
const _hoisted_85 = { class: "timeline-content-modern" }
const _hoisted_86 = { class: "time-badge" }
const _hoisted_87 = { class: "course-box" }
const _hoisted_88 = { class: "d-flex justify-content-between align-items-start mb-2" }
const _hoisted_89 = { class: "mb-0 fw-bold" }
const _hoisted_90 = { class: "text-muted mb-3" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-tie me-2" }, null, -1))
const _hoisted_92 = ["href"]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-video me-2" }, null, -1))
const _hoisted_94 = {
  key: 1,
  disabled: "",
  class: "btn btn-outline-secondary"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-check me-2" }, null, -1))
const _hoisted_96 = { key: 2 }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fw-semibold mb-4" }, "Emploi du temps hebdomadaire", -1))
const _hoisted_98 = { class: "table-responsive" }
const _hoisted_99 = { class: "table weekly-table" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Horaires", -1))
const _hoisted_101 = { class: "time-col" }
const _hoisted_102 = { class: "cell-header" }
const _hoisted_103 = { class: "text-muted d-block" }
const _hoisted_104 = { class: "cell-footer" }
const _hoisted_105 = { class: "time" }
const _hoisted_106 = ["href"]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-video" }, null, -1))
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = {
  key: 1,
  class: "badge bg-secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          (_ctx.studentInfo)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.studentInfo.prenom) + " " + _toDisplayString(_ctx.studentInfo.nom), 1),
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.studentInfo.filiere) + " – " + _toDisplayString(_ctx.studentInfo.niveau), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshAgenda && _ctx.refreshAgenda(...args))),
          class: "btn btn-outline-primary btn-refresh",
          disabled: _ctx.isLoading
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(['fa', _ctx.isLoading ? 'fa-spinner fa-spin' : 'fa-sync-alt'])
          }, null, 2),
          _createTextVNode(" Actualiser ")
        ], 8, _hoisted_7)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("ul", _hoisted_10, [
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("button", {
              class: _normalizeClass(['nav-link', { active: _ctx.activeTab === 'upcoming' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'upcoming'))
            }, [
              _hoisted_12,
              _createTextVNode(" Prochains cours "),
              (_ctx.upcomingCourses.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.upcomingCourses.length), 1))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("li", _hoisted_14, [
            _createElementVNode("button", {
              class: _normalizeClass(['nav-link', { active: _ctx.activeTab === 'today' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.activeTab = 'today'; _ctx.loadTodayCourses()})
            }, [
              _hoisted_15,
              _createTextVNode(" Aujourd'hui "),
              (_ctx.todayCourses.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.todayCourses.length), 1))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createElementVNode("button", {
              class: _normalizeClass(['nav-link', { active: _ctx.activeTab === 'week' }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'week'))
            }, [
              _hoisted_18,
              _createTextVNode(" Semaine ")
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_ctx.activeTab === 'upcoming')
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27))
                      : (!_ctx.upcomingCourses.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
                        : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcomingCourses, (cours) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: cours.id,
                                class: "course-card-modern mb-4"
                              }, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("h5", _hoisted_35, _toDisplayString(cours.matiere), 1),
                                    _createElementVNode("p", _hoisted_36, [
                                      _hoisted_37,
                                      _createTextVNode(_toDisplayString(cours.professeur), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("span", null, [
                                        _hoisted_39,
                                        _createTextVNode(_toDisplayString(_ctx.formatDateFull(cours.dateDebut)), 1)
                                      ]),
                                      _createElementVNode("span", null, [
                                        _hoisted_40,
                                        _createTextVNode(_toDisplayString(cours.heureDebut) + " – " + _toDisplayString(cours.heureFin), 1)
                                      ]),
                                      (!cours.estEnLigne)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                            _hoisted_42,
                                            _createTextVNode(_toDisplayString(cours.salle || 'Salle à confirmer'), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(['badge fs-6 px-3 py-2', cours.estEnLigne ? 'bg-success' : 'bg-info'])
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(['fa-solid me-1', cours.estEnLigne ? 'fa-video' : 'fa-chalkboard'])
                                    }, null, 2),
                                    _createTextVNode(" " + _toDisplayString(cours.estEnLigne ? 'En ligne' : 'Présentiel'), 1)
                                  ], 2)
                                ]),
                                (cours.estEnLigne)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      (_ctx.isCourseActive(cours))
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: cours.lienVisio,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            class: "btn btn-success btn-join shadow-sm"
                                          }, [
                                            _hoisted_45,
                                            _createTextVNode(" Rejoindre la visioconférence "),
                                            _hoisted_46
                                          ], 8, _hoisted_44))
                                        : (_openBlock(), _createElementBlock("button", _hoisted_47, [
                                            _hoisted_48,
                                            _createTextVNode(" Cours terminé ")
                                          ]))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    (_ctx.upcomingCourses.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createElementVNode("h4", _hoisted_53, _toDisplayString(_ctx.upcomingCourses[0].matiere), 1),
                            _createElementVNode("p", _hoisted_54, [
                              _hoisted_55,
                              _createTextVNode(" " + _toDisplayString(_ctx.formatDateFull(_ctx.upcomingCourses[0].dateDebut)), 1)
                            ]),
                            _createElementVNode("p", _hoisted_56, [
                              _hoisted_57,
                              _createTextVNode(" " + _toDisplayString(_ctx.upcomingCourses[0].heureDebut) + " – " + _toDisplayString(_ctx.upcomingCourses[0].heureFin), 1)
                            ]),
                            (_ctx.upcomingCourses[0].estEnLigne && _ctx.isCourseActive(_ctx.upcomingCourses[0]))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _ctx.upcomingCourses[0].lienVisio,
                                  target: "_blank",
                                  class: "btn btn-light btn-sm w-100 fw-semibold"
                                }, [
                                  _hoisted_59,
                                  _createTextVNode(" Rejoindre maintenant ")
                                ], 8, _hoisted_58))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _hoisted_62,
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _hoisted_65,
                            _createElementVNode("strong", _hoisted_66, _toDisplayString(_ctx.weeklyStats.total), 1)
                          ]),
                          _createElementVNode("div", _hoisted_67, [
                            _hoisted_68,
                            _createElementVNode("strong", _hoisted_69, _toDisplayString(_ctx.weeklyStats.online), 1)
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _hoisted_71,
                            _createElementVNode("strong", _hoisted_72, _toDisplayString(_ctx.weeklyStats.physical), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 'today')
            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                _createElementVNode("h4", _hoisted_74, [
                  _hoisted_75,
                  _createTextVNode(" Cours du " + _toDisplayString(_ctx.formatDateFull(new Date())), 1)
                ]),
                (_ctx.isLoadingToday)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, _hoisted_78))
                  : (!_ctx.todayCourses.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, _hoisted_83))
                    : (_openBlock(), _createElementBlock("div", _hoisted_84, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.todayCourses, (cours) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: cours.id,
                            class: "timeline-item-modern"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["timeline-dot", { 'active': _ctx.isCourseActive(cours) }])
                            }, null, 2),
                            _createElementVNode("div", _hoisted_85, [
                              _createElementVNode("div", _hoisted_86, _toDisplayString(cours.heureDebut) + " – " + _toDisplayString(cours.heureFin), 1),
                              _createElementVNode("div", _hoisted_87, [
                                _createElementVNode("div", _hoisted_88, [
                                  _createElementVNode("h5", _hoisted_89, _toDisplayString(cours.matiere), 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(['badge fs-6', _ctx.getCourseStatus(cours).class])
                                  }, _toDisplayString(_ctx.getCourseStatus(cours).text), 3)
                                ]),
                                _createElementVNode("p", _hoisted_90, [
                                  _hoisted_91,
                                  _createTextVNode(_toDisplayString(cours.professeur), 1)
                                ]),
                                (cours.estEnLigne && cours.lienVisio)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_ctx.isCourseActive(cours))
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: cours.lienVisio,
                                            target: "_blank",
                                            class: "btn btn-success shadow-sm"
                                          }, [
                                            _hoisted_93,
                                            _createTextVNode(" Rejoindre ")
                                          ], 8, _hoisted_92))
                                        : (_openBlock(), _createElementBlock("button", _hoisted_94, [
                                            _hoisted_95,
                                            _createTextVNode(" Terminé ")
                                          ]))
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 'week')
            ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                _hoisted_97,
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("table", _hoisted_99, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_100,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.joursOrdonnes, (jour) => {
                          return (_openBlock(), _createElementBlock("th", { key: jour }, _toDisplayString(jour), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heuresUniques, (heure) => {
                        return (_openBlock(), _createElementBlock("tr", { key: heure }, [
                          _createElementVNode("td", _hoisted_101, _toDisplayString(heure), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.joursOrdonnes, (jour) => {
                            return (_openBlock(), _createElementBlock("td", { key: jour }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCoursForDayAndTime(jour, heure), (cours) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: cours.id,
                                  class: _normalizeClass(['course-cell', { 'past': !_ctx.isCourseActive(cours) }])
                                }, [
                                  _createElementVNode("div", _hoisted_102, [
                                    _createElementVNode("strong", null, _toDisplayString(cours.matiere), 1),
                                    _createElementVNode("small", _hoisted_103, _toDisplayString(cours.professeur), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_104, [
                                    _createElementVNode("span", _hoisted_105, _toDisplayString(cours.heureDebut) + "–" + _toDisplayString(cours.heureFin), 1),
                                    (cours.estEnLigne && cours.lienVisio)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (_ctx.isCourseActive(cours))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                href: cours.lienVisio,
                                                target: "_blank",
                                                class: "btn btn-xs btn-success"
                                              }, _hoisted_108, 8, _hoisted_106))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_109, "Terminé"))
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2))
                              }), 128))
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}